// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const TimesLarge_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M19.28 18.22a.75.75 0 0 1-1.06 1.06L12 13.06l-6.22 6.22a.75.75 0 0 1-1.06-1.06L10.94 12 4.72 5.78a.75.75 0 0 1 1.06-1.06L12 10.94l6.22-6.22a.75.75 0 0 1 1.06 1.06L13.06 12Z',
  viewBox: '0 0 24 24',
  glyph: 'TimesLarge_Stroke2_Corner0_Rounded',
})
